import NotificationsCentreXpMessagesPage from "@faire/prototype-playground/workspace/anatoly/notifications-centre-xp-messages";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const InventoryPageUsagePage = lazy(
  () => import("../../workspace/anatoly/inventory-page-usage")
);
const BrandPortalMessagesPage = lazy(
  () => import("../../workspace/anatoly/brand-portal-messages")
);

export function AnatolyOstapenkoRoutes() {
  return (
    <Switch>
      <Route
        path="/anatoly/brand-portal-messages"
        component={BrandPortalMessagesPage}
      />
      <Route
        path="/anatoly/inventory-page-usage"
        component={InventoryPageUsagePage}
      />
      <Route
        path="/anatoly/notifications-centre-xp-messages"
        component={NotificationsCentreXpMessagesPage}
      />
    </Switch>
  );
}

export const slug = "anatoly";
